'use client';

import { useEffect, useState } from 'react';

export function useInternalApplicationDraft(isPersistedInternalApp: boolean) {
  const [isInternalApplication, setIsInternalApplication] = useState(
    isPersistedInternalApp,
  );

  useEffect(() => {
    setIsInternalApplication(isPersistedInternalApp);
  }, [isPersistedInternalApp]);

  return {
    isInternalApplication,
    setIsInternalApplication,
    isPersistedInternalApp,
    isPendingEnable: isInternalApplication && !isPersistedInternalApp,
    isPendingDisable: !isInternalApplication && isPersistedInternalApp,
    isInternalAccessQueryEnabled:
      isInternalApplication || isPersistedInternalApp,
  };
}

export type InternalApplicationDraft = ReturnType<
  typeof useInternalApplicationDraft
>;
